// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./demo-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./demo-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./demo-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-block__container {
  background-color: var(--white-color);
}
.demo-block__container h1 {
  color: var(--web-primary-color);
}

.explore-demo__content {
  display: grid;
}

.explore-demo__img1, .explore-demo__img2, .explore-demo__img3 {
  background-size: cover;
  background-repeat: no-repeat;
  background-color: lightgray;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
}

.explore-demo__img1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.explore-demo__img2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.explore-demo__img3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media only screen and (min-device-width: 320px) {
  .explore-demo__content {
    row-gap: 20px;
    grid-template-rows: repeat(3, 175px);
    grid-template-columns: 328px;
    margin-bottom: 20px;
  }
}
@media only screen and (min-device-width: 768px) {
  .explore-demo__content {
    row-gap: 20px;
    grid-template-rows: repeat(3, 355px);
    grid-template-columns: minmax(auto, 680px);
    margin-bottom: 20px;
  }
}
@media only screen and (min-device-width: 992px) {
  .explore-demo__content {
    height: 403px;
    column-gap: 36px;
    row-gap: 46px;
    grid-template-rows: 176px 176px;
    grid-template-columns: minmax(auto, 755px) minmax(auto, 337px);
    margin-bottom: 36px;
  }
  .explore-demo__img1 {
    grid-row-start: span 2;
  }
}
@media only screen and (min-device-width: 1366px) {
  .explore-demo__content {
    height: 553px;
    column-gap: 36px;
    row-gap: 46px;
    grid-template-rows: 255px 255px;
    grid-template-columns: 2fr 1fr;
    margin-bottom: 36px;
  }
  .explore-demo__img1 {
    grid-row-start: span 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LandingPage/components/DemoBlock/blockDemo.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AAAE;EACE,+BAAA;AAEJ;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,yCAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE;IACE,aAAA;IACA,oCAAA;IACA,4BAAA;IACA,mBAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;IACA,oCAAA;IACA,0CAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;IACA,gBAAA;IACA,aAAA;IACA,+BAAA;IACA,8DAAA;IACA,mBAAA;EADF;EAGA;IACE,sBAAA;EADF;AACF;AAIA;EACE;IACE,aAAA;IACA,gBAAA;IACA,aAAA;IACA,+BAAA;IACA,8BAAA;IACA,mBAAA;EAFF;EAIA;IACE,sBAAA;EAFF;AACF","sourcesContent":[".demo-block__container{\n  background-color: var(--white-color);\n  h1 {\n    color: var(--web-primary-color);\n  }\n\n}\n.explore-demo__content {\n  display: grid;\n}\n\n.explore-demo__img1, .explore-demo__img2, .explore-demo__img3 {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: lightgray;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);\n}\n\n.explore-demo__img1 {\n  background-image: url(\"demo-1.jpg\");\n}\n\n.explore-demo__img2 {\n  background-image: url(\"demo-2.jpg\");\n}\n\n.explore-demo__img3 {\n  background-image: url(\"demo-3.jpg\");\n}\n\n@media only screen and (min-device-width: 320px) {\n  .explore-demo__content {\n    row-gap: 20px;\n    grid-template-rows: repeat(3, 175px);\n    grid-template-columns: 328px;\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .explore-demo__content {\n    row-gap: 20px;\n    grid-template-rows: repeat(3, 355px);\n    grid-template-columns: minmax(auto, 680px);\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .explore-demo__content {\n    height: 403px;\n    column-gap: 36px;\n    row-gap: 46px;\n    grid-template-rows: 176px 176px;\n    grid-template-columns: minmax(auto, 755px) minmax(auto, 337px);\n    margin-bottom: 36px;\n  }\n  .explore-demo__img1 {\n    grid-row-start: span 2;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .explore-demo__content {\n    height: 553px;\n    column-gap: 36px;\n    row-gap: 46px;\n    grid-template-rows: 255px 255px;\n    grid-template-columns: 2fr 1fr;\n    margin-bottom: 36px;\n  }\n  .explore-demo__img1 {\n    grid-row-start: span 2;\n  }\n}\n\n//@media only screen and (min-device-width: 1920px) {\n//  .explore-demo__content{\n//    height: 553px;\n//    column-gap: 36px;\n//    row-gap: 46px;\n//        grid-template-rows: 255px 255px;\n//    grid-template-columns: 2fr 1fr;\n//  }\n//  .explore-demo__img1{\n//    grid-row-start: span 2;\n//  }\n//}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
